import React, { useEffect, useState } from "react";
import { connect  } from "react-redux";
import { Card, Divider, Upload, Form, Input, message } from "antd";
import {  } from 'antd';
import FormItem from "components/fields/FormItem";
import { Globe, House, Linkedin, Mail, Phone, Save, Upload as UploadIcon } from "lucide-react";
import { emailField, requiredField } from "utils/crudSagaHelper";
import { doMyProfileUpdate, getMyProfile } from "../../../../redux/myprofile/myProfileState";
import CrudButtons from "components/button/crudbuttons";
import { formatURL } from "utils/index";
import { useNavigate } from 'react-router-dom';
import APIService from '../../../../services/apiservice';
import { showLoading, hideLoading } from '../../../../redux/layout/layoutState';
import { 
    getAuthUserReload
 } from '../../../../redux/auth/authState';

const MyProfileForm = ({ getRecord, recordData, doUpdate, requesting, error, mode, showImporting, hideImporting, getUpdatedAuthUser}) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const navigate = useNavigate();
  const [resumeFile, setResumeFile] = useState();

  useEffect(() => {
        getRecord();
  }, [getRecord]);
    
  useEffect(() => {
    if(recordData){			
      const { contact_details, address, applicant, ...restData } = recordData;
			const initialValues = {
				...Object.fromEntries(
					Object.entries(contact_details || {}).map(([key, value]) => [`contact_${key}`, value])
				),
				...Object.fromEntries(
					Object.entries(address || {}).map(([key, value]) => [`address_${key}`, value])
				),				
        ...Object.fromEntries(
					Object.entries(applicant || {}).map(([key, value]) => [`applicant_${key}`, value])
				),	
				...restData,
			};

			form.resetFields();
			form.setFieldsValue(initialValues);

      }
  }, [recordData, form]);

  const handleUpload = async (file) => {
		const isValidType =
      file.type === 'application/pdf' ||
      file.type === 'application/msword' ||
      file.type ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

    if (!isValidType) {
      message.error('Only PDF, DOC, DOCX files are allowed');
      return Upload.LIST_IGNORE;
    }

    const isLessThan5MB = file.size / 1024 / 1024 < 5;

    if (!isLessThan5MB) {
      message.error('File must be smaller than 5MB');
      return Upload.LIST_IGNORE;
    }

    setResumeFile(file);

    return false; 
	}

  const onSubmit = async (formData) => {
    try {

      const { resume, ...rest } = formData;

      if(resumeFile){
        showImporting('Uploading...');
        await APIService.doUploadRequest(`api/v1/my/resume/upload`, resumeFile);
        hideImporting();
      }
      
      doUpdate(rest);
      getUpdatedAuthUser();

    } catch (error) {
      console.error('Save failed:', error);
    }
  };

  return (
    <Card>
      
      <div className="p-5 pt-2 space-y-4">
          <Form form={form}
            layout="vertical"
            onFinish={onSubmit}
            > 
            <CrudButtons
                  mode={mode}
                  submitLabel="Save Changes"
                  editLabel="Edit Profile"
                  withBack={false}
                  recordId={recordData?.ude_id}
                  baseRoute="/my/profile"
                />
            { mode === 'edit' && 
              <FormItem
                name="resume"
                icon={UploadIcon}
                label="Upload Your Resume"
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) return e;
                  return e?.fileList;
                }}
                rules={recordData?.applicant?.apl_resume > 0 ? [] : [
                  {
                    required: true,
                    message: 'Please upload your resume',
                  },
                ]}
              >
                <Upload.Dragger
                  accept=".pdf,.doc,.docx"
                  maxCount={1}
                  beforeUpload={handleUpload}
                >
                  <div className="flex flex-col items-left gap-2">
                    <div className="btn-gradient-emerald px-3 py-1.5 rounded-lg w-[100px]">
                        Choose File
                    </div>
                    
                    <p className="text-sm text-left">
                      Accepted formats: PDF, DOC, DOCX (Max 5MB)
                    </p>
                  </div>
                </Upload.Dragger>
              </FormItem>
            }
            

            <Divider/>

            <h4 className="text-gray-900 text-base font-medium mb-4">Personal Information</h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
                <FormItem
                  label="First Name"
                  name="ude_first_name"
                  rules={[requiredField()]}
                  value={recordData?.ude_first_name}
                >
                  { mode === 'edit' &&
                    <Input id="ude_first_name"
                      className="input-field"
                      maxLength={100}
                      placeholder="Enter First Name"
                      readOnly=""
                    />
                  }
                </FormItem>
                <FormItem
                  label="Last Name"
                  name="ude_last_name"
                  rules={[requiredField()]}
                  value={recordData?.ude_last_name}
                >
                  { mode === 'edit' &&
                    <Input id="ude_last_name"
                      className="input-field"
                      maxLength={100}
                      placeholder="Enter Last Name"
                    />
                  }
                </FormItem>
              <div>
                <FormItem
                  label="Email Address"
                  name="contact_cde_email"
                  rules={[requiredField(), emailField()]}
                  icon={Mail}
                  value={recordData?.contact_details?.cde_email}
                >
                  { mode === 'edit' &&
                    <Input id="contact_cde_email"
                      className="input-field"
                      maxLength={100}
                      placeholder="username@domain.com"
                    />
                  }
                </FormItem>
              </div>  
              <FormItem
                label="Phone Number"
                name="contact_cde_phone_number"
                rules={[requiredField()]}
                icon={Phone}
                value={recordData?.contact_details?.cde_phone_number}
              >
                { mode === 'edit' &&
                  <Input id="contact_cde_phone_number"
                    className="input-field"
                    maxLength={20}
                    placeholder="+1 (555) 123-4567"
                  />
                }
              </FormItem> 
            </div>
            <FormItem
              label="Street Address"
              name="address_add_address_line1"
              rules={[requiredField()]}
              icon={House}
              value={recordData?.address?.add_address_line1}
            >
              { mode === 'edit' &&
                <Input id="address_add_address_line1"
                  className="input-field"
                  maxLength={100}
                />
              }
            </FormItem> 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4">
              <FormItem
                label="City"
                name="address_add_city"
                rules={[requiredField()]}
                value={recordData?.address?.add_city}
              >
                { mode === 'edit' &&
                  <Input id="address_add_city"
                    className="input-field"
                    maxLength={50}
                  />
                }
              </FormItem> 
              <FormItem
                label="State/Province"
                name="address_add_state"
                rules={[requiredField()]}
                value={recordData?.address?.add_state}
              >
                { mode === 'edit' &&
                  <Input id="address_add_state"
                    className="input-field"
                    maxLength={50}
                  />
                }
              </FormItem> 
              <FormItem
                label="ZIP/Postal Code"
                name="address_add_postal_code"
                rules={[requiredField()]}
                value={recordData?.address?.add_postal_code}
              >
                { mode === 'edit' &&
                  <Input id="address_add_postal_code"
                    className="input-field"
                    maxLength={10}
                  />
                }
              </FormItem> 
            </div>
            <Divider/>
              <div className="flex flex-col">
                <FormItem
                  label="LinkedIn Profile URL"
                  name="applicant_apl_linkedin"
                  icon={Linkedin}
                >
                  { mode === 'edit' ?
                  <Input id="applicant_apl_linkedin"
                    className="input-field"
                    maxLength={100}
                  />
                  :
                  <div className="text-base label-value">
                    <a href={formatURL(recordData?.applicant?.apl_linkedin)} target="_blank">{recordData?.applicant?.apl_linkedin}</a>
                  </div>
                  }
                </FormItem> 
                <FormItem
                  label="Portfolio/Website URL"
                  name="applicant_apl_portfolio_link"
                  icon={Globe}
                >
                  { mode === 'edit' ?
                  <Input id="applicant_apl_portfolio_link"
                    className="input-field"
                    maxLength={100}
                  />
                  :
                  <div className="text-base label-value">
                    <a href={formatURL(recordData?.applicant?.apl_portfolio_link)} target="_blank">{recordData?.applicant?.apl_portfolio_link}</a>
                  </div>
                  }
                </FormItem> 

                <FormItem
                  label="Professional Bio"
                  name="applicant_apl_overview"
                  icon={Globe}
                >
                  <TextArea
                      allowClear
                      rows={5}
                      maxLength={255}
                      className={`
                          resize-none bg-transparent pr-3 text-[13px] sm:text-[14px] 
                          placeholder:text-muted-foreground
                          disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
                          border-gray-200 dark:!border-white/10 dark:text-white
                      `}
                      readOnly={ mode === 'view'}
                  />
                </FormItem>
              </div>

              <CrudButtons
                  mode={mode}
                  submitLabel="Save Changes"
                  editLabel="Edit Profile"
                  withBack={false}
                  recordId={recordData?.ude_id}
                  baseRoute="/my/profile"
                />

          </Form>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.myProfile.record?.data,
  requesting: state.myProfile.record?.requesting,
  error: state.myProfile.record?.error,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: () => dispatch(getMyProfile()),
  doUpdate: (data) => dispatch(doMyProfileUpdate(data)),
  showImporting: (message) => dispatch(showLoading(message)),
  hideImporting: () => dispatch(hideLoading()),
  getUpdatedAuthUser: () => dispatch(getAuthUserReload()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProfileForm);